export const MOBILE = 'MOBILE';
// Map tileSize prefix to tile sizes
export const TILE_SIZE_MAP = {
	medium: 'md',
	small: 'sm'
};
// Item list type for custom brand tiles configured via Composer
export const ITEM_LIST_TYPE = 'group-logo';

// Base URL for inventory page navigation by brand make
export const ALL_INVENTORY_BASE_URL = '/all-inventory/index.htm';
